function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.57 19.91c.4 0 .73-.32.73-.71v-7.86l-.06-1.16.49.57 1.08 1.16c.14.14.32.21.5.21.35 0 .65-.25.65-.62 0-.2-.08-.34-.21-.47l-2.63-2.52a.74.74 0 00-1.1 0l-2.63 2.52a.62.62 0 00-.2.47c0 .37.29.63.65.63.18 0 .36-.08.49-.22l1.08-1.16.49-.58-.06 1.17v7.86c0 .39.33.71.73.71zm4.5 6.25c1.69 0 2.56-.88 2.56-2.55v-7.68c0-1.67-.87-2.55-2.57-2.55h-2.1v1.56h2c.71 0 1.12.37 1.12 1.12v7.4c0 .76-.4 1.13-1.12 1.13h-8.8c-.71 0-1.11-.37-1.11-1.12v-7.4c0-.76.4-1.13 1.11-1.13h2.04v-1.56h-2.14c-1.69 0-2.57.87-2.57 2.55v7.68c0 1.67.88 2.55 2.57 2.55h9z",
  fill: "#fff",
  fillRule: "nonzero"
});

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.3c895087.svg";
export { ForwardRef as ReactComponent };